<template>
  <v-container fluid class="pa-4 pa-sm-8">
    <v-dialog v-model="showDialog" max-width="1000">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-2 light--text mb-sm-4 text-capitalize" v-on="on">
          <v-icon>mdi-magnify</v-icon>
          Select To Customer
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="justify-center">
          <span class="dark--text text-h6"> Customers</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="show_dialog_box1 = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout class="mt-6" wrap>
            <v-flex xs12 sm4 lg4>
              <v-select :items="fieldsToSearch" v-model="fieldToSearch" item-text="key" item-value="value" label="Field To Search" dense attach solo></v-select>
            </v-flex>
            <v-flex xs12 sm4 lg4 class="ml-3">
              <v-text-field placeholder="Search.." v-model="search" solo dense @keydown.enter="runSearch()">
                <template v-slot:prepend-inner>
                  <v-icon color="dark" v-if="search.length > 0" @click="clearSearch()">mdi-close</v-icon>
                  <v-icon v-if="search.length == 0" color="dark" @click="runSearch()">mdi-magnify</v-icon>
                </template>
              </v-text-field>
            </v-flex>

            <v-flex xs3 sm2 lg1 class="mb-4 ml-3 ms-5 mb-sm-0">
              <v-btn class="light--text" color="primary" height="40px" dense @click="runSearch()">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout> </v-layout>

          <v-data-table
            :headers="headers"
            :items="itemsWithSno"
            class="elevation-1"
            :items-per-page="25"
            :options.sync="options"
            :loading="loading"
            :mobile-breakpoint="0"
            :server-items-length="totalItemsCount"
            :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
          >
            <template v-slot:item.customerId="{ item }">
              {{ padLeft(item.customerId, 4) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn color="primary" class="text-capitalize light--text me-3" height="40px" @click="onSelectCustomer(item)">
                Select
              </v-btn>
            </template>
            <template v-slot:item.name="{ item }">
              <router-link
                v-if="item.user"
                :to="{
                  name: 'CustomerDetails',
                  params: { customerId: item._id },
                  query: { customerId: item._id },
                }"
                class="mx-auto"
              >
                {{ item.user.firstnameEn[0].toUpperCase() + item.user.firstnameEn.substring(1) }}
                <!-- <div class="mx-1" /> -->
                {{ item.user.lastnameEn[0].toUpperCase() + item.user.lastnameEn.substring(1) }}
              </router-link>
              <!-- </v-row> -->
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      imageUrl: process.env.VUE_APP_BASE_URL,
      dialog: false,
      editDialog: false,
      search: "",
      showDialog: false,
      headers: [
        {
          text: "#",
          value: "customerId",
          width: 100,
        },
        // { text: "Avatar", value: "photo" },
        { text: "Customer Name", value: "name", width: 150 },

        {
          text: "Contact Number",
          value: "user.phone",
          width: 170,
          sortable: false,
        },

        { text: "Action", value: "actions", width: 40, sortable: false },
      ],
      tags: [],
      customerList: [],
      totalItemsCount: 25,
      options: {
        itemsPerPage: 25,
        page: 1,
        sortDesc: [false],
        sortBy: [],
      },
      variables: {
        limit: 25,
        skip: 0,
        sortDesc: false,
        sortBy: "",
        fieldToSearch: "CUSTOMER_ID",
      },
      loading: true,
      fieldToSearch: "PHONE",
      fieldsToSearch: [
        { key: "Customer Id", value: "CUSTOMER_ID" },
        { key: "Customer Name", value: "CUSTOMER_NAME" },
        { key: "Contact Number", value: "PHONE" },
      ],
    };
  },

  created() {
    if (!this.hasRole(this.AdminUserPermissions.CUSTOMER_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },
  apollo: {
    customers() {
      this.loading = true;
      return {
        query: require("../api/customers.graphql"),
        variables: this.variables,
        result({ data, loading }) {
          this.loading = loading;
          this.customerList = data.customers.customers;
          this.totalItemsCount = data.customers.totalCount;
        },
      };
    },
  },
  computed: {
    itemsWithSno() {
      if (this.customerList == null) return [];
      return this.customerList.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  methods: {
    onSelectCustomer(customer) {
      this.showDialog = false;
      this.$emit("selectCustomer", customer);
    },
    padLeft(number, length) {
      var stringValue = "" + number;
      while (stringValue.length < length) {
        stringValue = "0" + stringValue;
      }
      return stringValue;
    },

    clearFilter() {
      this.search = "";

      this.$apollo.queries.customers.refetch({
        limit: 25,
        skip: 0,
        searchKey: "",
        fieldToSearch: this.fieldToSearch,
      });
    },
    runSearch() {
      this.$apollo.queries.customers.refetch({
        limit: 25,
        skip: 0,
        searchKey: this.search,
        fieldToSearch: this.fieldToSearch,
      });
    },
    clearSearch() {
      this.search = "";
      this.$apollo.queries.customers.refetch({
        limit: 25,
        skip: 0,
        searchKey: "",
        fieldToSearch: this.fieldToSearch,
      });
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.loading) {
          this.variables.limit = this.options.itemsPerPage;
          this.variables.skip = this.options.page * this.options.itemsPerPage - this.options.itemsPerPage;
          this.$apollo.queries.customers.refetch({
            limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 500,
            skip: this.variables.skip,
            sortDesc: this.options.sortDesc ? this.options.sortDesc[0] : "",
            sortBy: this.options.sortBy ? this.options.sortBy[0] : "",
            fieldToSearch: this.fieldToSearch,
          });
        }
      },
      deep: true,
    },

    dialog(val) {
      val || this.close();
    },
  },
};
</script>

<style scoped></style>
